import React from 'react';
import { useLingui } from '@lingui/react';
import { Box, Typography } from '@mui/material';

export const NotFoundError = ({ colorText }) => {
  const { i18n } = useLingui();

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1,
        width: '100vw',
        height: '100vh',
        alignContent: 'center',
        textAlign: 'center',
        backgroundColor: '#202020',
        color: colorText || '#fff',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: '32px',
          fontWeight: '600',
        }}
      >
        {i18n._('Oops!')}
      </Typography>
      <Typography
        component="span"
        sx={{
          opacity: 0.85,
        }}
      >
        {i18n._("We can't seem to find the page you are looking for.")}
      </Typography>
    </Box>
  );
};
